import { render } from "./testZxing.vue?vue&type=template&id=bb4521b2"
import script from "./testZxing.vue?vue&type=script&lang=js"
export * from "./testZxing.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__